import { z } from 'zod';

interface VerificationTokenResponse {
	token: string;
}

export const VerificationTokenSchema: z.ZodType<VerificationTokenResponse> =
	z.object({
		token: z.string(),
	});
